import { render } from "./GeneralSettingView.vue?vue&type=template&id=4bcb9199&scoped=true"
import script from "./GeneralSettingView.vue?vue&type=script&lang=js"
export * from "./GeneralSettingView.vue?vue&type=script&lang=js"

import "./GeneralSettingView.vue?vue&type=style&index=0&id=4bcb9199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcb9199"]])

export default __exports__